import { fmtDate } from "./format";
import { useT } from "./i18n";

const Row = ({ k, v, testid }) => (
  <div className="flex justify-between gap-4 py-1.5 border-b border-[#EEEEEA] last:border-0">
    <span className="font-mono text-[10px] uppercase tracking-widest text-[#525252] shrink-0 pt-0.5">{k}</span>
    <span className="text-sm text-right text-[#111110] font-medium break-words" data-testid={testid}>{v || "—"}</span>
  </div>
);

export function QuoteHeader({ company, repair, state, validUntil }) {
  const { t, locale } = useT();
  const badge = {
    pending: [t("state_pending"), "bg-[#FFF7E0] text-[#8A6100]"],
    accepted: [t("state_accepted"), "bg-[#F0F4E8] text-[#3F5222]"],
    rejected: [t("state_rejected"), "bg-[#FDEDE7] text-[#9B2C1F]"],
    expired: [t("state_expired"), "bg-neutral-100 text-neutral-500"],
  }[state] || ["", ""];
  return (
    <div className="ds-card p-5" data-testid="quote-header">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="font-display font-black text-xl tracking-tight text-[#111110]">{company?.name || "iRepairs"}</div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#6E8B3D] mt-0.5">{t("title")}</div>
        </div>
        {badge[0] && (
          <span className={`shrink-0 px-2.5 py-1 rounded-full text-[10px] font-mono uppercase tracking-widest ${badge[1]}`} data-testid="quote-state-badge">
            {badge[0]}
          </span>
        )}
      </div>
      <div className="mt-4">
        <Row k={t("repair_no")} v={repair.code} testid="quote-repair-code" />
        <Row k={t("customer")} v={repair.customer?.name} testid="quote-customer" />
        <Row k={t("device")} v={`${repair.device_type || ""} ${repair.brand || ""}`.trim()} testid="quote-device" />
        <Row k={t("model")} v={repair.model} testid="quote-model" />
        <Row k={t("serial")} v={repair.serial} testid="quote-serial" />
        <Row k={t("date")} v={fmtDate(repair.created_at || repair.entry_date, locale)} />
        {repair.estimated_date && (
          <Row k={t("estimated_date")} v={repair.estimated_date} testid="quote-estimated-date" />
        )}
        <Row k={t("validity")} v={validUntil ? t("valid_until", { fecha: fmtDate(validUntil, locale) }) : "—"} testid="quote-valid-until" />
      </div>
      {repair.diagnosis && (
        <div className="mt-4 rounded-lg bg-[#FAFAF6] border border-[#E5E5E0] p-3">
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">{t("diagnosis")}</div>
          <p className="text-sm mt-1 whitespace-pre-line" data-testid="quote-diagnosis">{repair.diagnosis}</p>
        </div>
      )}
    </div>
  );
}
